import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.79 5.33c0-.368.3-.667.668-.667h9.333c.368 0 .667.299.667.667v2a.667.667 0 0 1-.667.667H3.458a.667.667 0 0 1-.667-.667zm1.334.667v.666h8v-.666z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.359 6.67a.667.667 0 0 1 .758.561l.915 6.099h4.185l.915-6.099a.667.667 0 0 1 1.318.198l-1 6.666a.67.67 0 0 1-.66.568H5.459a.67.67 0 0 1-.66-.568l-1-6.666a.667.667 0 0 1 .56-.758M5.458 3.997a.667.667 0 0 0-.667.666v.667a.667.667 0 1 1-1.333 0v-.667a2 2 0 0 1 2-2h5.333a2 2 0 0 1 2 2v.667a.667.667 0 0 1-1.333 0v-.667a.667.667 0 0 0-.667-.666z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.124 1.33c.368 0 .667.298.667.667V3.33a.667.667 0 0 1-1.333 0V1.997c0-.369.298-.667.666-.667",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })